import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CurrencyStoreActions,
  CurrencyStoreSelectors,
  CurrencyStoreReducer,
} from './index';
import { CurrencyDto } from '@cradua/data';

@Injectable()
export class CurrencyFacade {
  constructor(
    private store: Store<CurrencyStoreReducer.CurrencyPartialState>
  ) {}

  countryRecord$ = this.store.select(CurrencyStoreSelectors.getSelected);
  countryRecordError$ = this.store.select(
    CurrencyStoreSelectors.getCurrencyError
  );

  getselected() {
    return this.store.select(CurrencyStoreSelectors.getSelected);
  }

  get isLoadingCurrency() {
    this.store.dispatch(CurrencyStoreActions.loadCurrency());
    return this.store.select(CurrencyStoreSelectors.loadingCurrency);
  }

  get loadCurrency() {
    this.store.dispatch(CurrencyStoreActions.loadCurrency());
    return this.store.select(CurrencyStoreSelectors.getAllCurrency);
  }

  addCurrency(newCurrency: CurrencyDto[]) {
    this.store.dispatch(CurrencyStoreActions.addCurrency({ newCurrency }));
  }

  updateCurrency(updateCurrency: CurrencyDto[]) {
    this.store.dispatch(
      CurrencyStoreActions.updateCurrency({ updateCurrency })
    );
  }

  removeCurrency(ids: string[]) {
    this.store.dispatch(CurrencyStoreActions.removeCurrency({ ids }));
  }
}
